/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import AppText from '../../../../../common/AppText';
import { useMediaQueries } from '../../../../../../helpers/hooks';

const WsTitleBlock = ({
  entity,
  config,
  mediaQueries,
  displayFunctions,
  ...rest
}) => {
  const { isTabletOrSmaller } = mediaQueries || useMediaQueries();

  return (
    <AppText
      style={{
        fontSize: isTabletOrSmaller
          ? Math.max(config.titleMobileSize * 1 || 20, 18)
          : Math.max(config.titleSize * 1 || 28, 18),
        fontWeight: 500
      }}
    >
      {entity.title}
    </AppText>
  );
};

WsTitleBlock.propTypes = {
  config: PropTypes.object,
  displayFunctions: PropTypes.object,
  entity: PropTypes.object,
  mediaQueries: PropTypes.object
};

export default WsTitleBlock;
